import React from 'react';

const industries = [
  {
    title: 'Healthcare & Life Sciences',
    description: 'Secure digital workflows, data platforms, and integration support for patient-centered organizations.'
  },
  {
    title: 'Financial Services',
    description: 'Modern applications, analytics, and risk-aware delivery practices for regulated business environments.'
  },
  {
    title: 'Public Sector & Education',
    description: 'Accessible, scalable solutions that help agencies and institutions serve communities more efficiently.'
  },
  {
    title: 'Technology & Startups',
    description: 'Product engineering, cloud modernization, and specialist staffing to accelerate growth-stage roadmaps.'
  }
];

function Industries() {
  return (
    <section id="industries" style={{ backgroundColor: '#ffffff' }}>
      <div style={{
        background: 'linear-gradient(to right, #0f172a, #1e3a8a)',
        padding: '4rem 2rem',
        color: 'white',
        textAlign: 'center'
      }}>
        <h1 style={{ fontSize: '2.5rem', fontWeight: 'bold', margin: 0 }}>Industries We Serve</h1>
        <p style={{ maxWidth: '760px', margin: '1rem auto 0', lineHeight: '1.6' }}>
          We pair technology delivery expertise with practical industry context so every engagement is built around real operational needs.
        </p>
      </div>

      <div style={{
        maxWidth: '1100px',
        margin: '0 auto',
        padding: '3rem 2rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
        gap: '1.5rem'
      }}>
        {industries.map((industry) => (
          <article
            key={industry.title}
            style={{
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              padding: '1.5rem',
              boxShadow: '0 8px 20px rgba(15, 23, 42, 0.05)'
            }}
          >
            <h2 style={{ color: '#1e3a8a', fontSize: '1.2rem', marginTop: 0 }}>{industry.title}</h2>
            <p style={{ color: '#475569', lineHeight: '1.6', marginBottom: 0 }}>{industry.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Industries;
